export enum DtwinCompatibilityQuickFilter {
  ALL_DEVICES = "allDevices",
  COMPATIBLE_DEVICES = "compatibleDevices",
  INCOMPATIBLE_DEVICES = "incompatibleDevices",
}
